import { useBreakpoint } from '@xstyled/styled-components';
import { useMemo } from 'react';

export type Breakpoints = '_' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';

/**
 * Helper type to make an item property responsive
 */
export type Responsive<T> = T | { [key in Breakpoints]?: T };

const rankedBreakpoints: Breakpoints[] = [
  '_',
  'xs',
  'sm',
  'md',
  'lg',
  'xl',
  '2xl'
];

/**
 * Helper hook that returns the responsive value that matches the current breakpoint
 * @param value A responsive object
 * @returns The object value corresponding to the current breakpoint
 */
export function useResponsive<T>(value?: Responsive<T>) {
  const breakpoint = useBreakpoint() as Breakpoints | null;
  return useMemo(() => {
    if (
      breakpoint &&
      value &&
      typeof value === 'object' &&
      ('_' in value! ||
        'xs' in value! ||
        'sm' in value! ||
        'md' in value! ||
        'lg' in value! ||
        'xl' in value! ||
        '2xl' in value!)
    ) {
      for (let i = rankedBreakpoints.indexOf(breakpoint); i >= 0; i--) {
        if (rankedBreakpoints[i] in value) {
          return value[rankedBreakpoints[i]];
        }
      }
      return;
    }

    return value as T;
  }, [breakpoint]);
}
